import { render, staticRenderFns } from "./basic_edit.vue?vue&type=template&id=4c091f07&"
import script from "./basic_edit.vue?vue&type=script&lang=js&"
export * from "./basic_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports